module.exports = __webpack_public_path__ + "static/media/SGA_logo_transparent.4328d1dd.png";